import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CalendarRange, Home, ListChecks, ShieldCheck, User2, LogOut } from "lucide-react";

export default function BookerLayout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const NavItem = ({ to, icon: Icon, label, testid }) => {
    const active = loc.pathname === to || loc.pathname.startsWith(to + "/");
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-colors ${
          active ? "text-amber" : "text-light-ink/70 hover:text-ink"
        }`}
      >
        <Icon className="w-5 h-5" strokeWidth={1.6} />
        <span className="text-[11px] font-medium tracking-tight">{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-h-screen flex flex-col bg-cream text-ink">
      <header className="sticky top-0 z-40 bg-cream/90 backdrop-blur border-b border-tablo-border/60">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/home" className="flex items-center gap-2" data-testid="booker-brand-link">
            <span className="font-serif text-2xl text-ink">Tablo</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-amber font-medium">Hyderabad</span>
          </Link>
          <div className="flex items-center gap-3">
            {user && (
              <button
                onClick={() => { logout(); nav("/"); }}
                className="text-sm text-light-ink hover:text-ink flex items-center gap-1"
                data-testid="booker-logout-btn"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.6} /> Logout
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-3xl w-full mx-auto px-5 pb-24 pt-6">{children}</main>

      {user && (
        <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-tablo-border" data-testid="booker-bottom-nav">
          <div className="max-w-3xl mx-auto px-2 flex">
            <NavItem to="/home" icon={Home} label="Plan" testid="nav-home" />
            <NavItem to="/my-bookings" icon={CalendarRange} label="Bookings" testid="nav-mybookings" />
            {user.is_approver && (
              <NavItem to="/approvals" icon={ShieldCheck} label="Approvals" testid="nav-approvals" />
            )}
            <NavItem to="/profile" icon={User2} label="Profile" testid="nav-profile" />
          </div>
        </nav>
      )}
    </div>
  );
}
